export var raRealTimeLanguageFrench = {
    'ra-realtime': {
        notification: {
            title: 'Attention',
            record: {
                updated: 'Cet enregistrement a été modifié par un autre utilisateur',
                deleted: "Cet enregistrement a été supprimé et n'est plus disponible",
            },
        },
    },
};
export default raRealTimeLanguageFrench;
